<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">合同编号</p>
        <el-input v-model="contractNumber" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">合同名称</p>
        <el-input v-model="contractName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">所属公司</p>
        <el-select v-model="companyId" placeholder="请输入" class="inputDiv" clearable>
          <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName"
            :value="item.companyId"></el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">楼宇名称</p>
        <el-select v-model="buildingId" placeholder="请选择" clearable class="inputDiv">
          <el-option v-for="item in buildingValueList" :key="item.buildingId" :label="item.buildingName"
            :value="item.buildingId"></el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">合同状态</p>
        <el-select v-model="status" placeholder="请选择" class="inputDiv" clearable>
          <el-option v-for="item in contractStatusValueList" :key="item.status" :label="item.value"
            :value="item.status"></el-option>
        </el-select>
      </div>
      <div class="stateDivText">
        <p class="searchText">合同时效</p>
        <el-date-picker v-model="timeValue" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </div>
      <div class="stateDiv" style="margin-left: 0.5rem;">
        <p class="searchText">地址</p>
        <el-input v-model="rentalDetailAddr" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="btnDiv" style="margin-left: 0rem;">
        <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
        <el-button v-if="roleName === '招商员' || roleName === '招商经理'" class="searchBtn" type="warning" @click="addContract">新增合同</el-button>
      </div>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{prop: 'id', order: 'descending'}"
          style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width"></el-table-column>
          </template>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope" class="tableButton">
              <!-- <el-button class="tableBtn" @click="pricePreview(scope.row)" v-if="scope.row.attachmentUrl" type="text"
                size="small">价格审批单预览
              </el-button> -->
              <!-- <el-button class="tableBtn" v-if="roleName !== '法务员'" @click="printFun(scope.row)" type="text"
                size="small">打印
              </el-button> -->
              <el-button class="tableBtn" @click="downloadPdf(scope.row)" type="text"
                size="small">下载
              </el-button>
              <el-button class="tableBtn" @click="previewFun(scope.row)" type="text" size="small">预览</el-button>
              <el-button class="tableBtn" v-if="scope.row.contractStatus === 7" @click="fileFun(scope.row)" type="text"
                size="small">归档
              </el-button>
              <el-button class="tableBtn" v-if="scope.row.contractStatus === 7" @click="showHistoryList(scope.row)"
                type="text" size="small">查看
              </el-button>
              <!-- <el-button class="tableBtn"
                v-if="roleName !== '招商员' && getInfoByContractStatus(roleName) === scope.row.contractStatus"
                @click="checkFun(scope.row)" type="text" size="small">审批
              </el-button> -->
              <!-- {{getInfoByContractStatus(roleName)}} -->
              <!-- <el-button class="tableBtn"
                v-if="roleName !== '招商员' && getInfoByContractStatus(roleName) === scope.row.contractStatus"
                @click="checkFun(scope.row)" type="text" size="small">审批
              </el-button> -->
              <el-button class="tableBtn" v-if="roleName === '招商员' && scope.row.contractStatus === 0"
                @click="submitFun(scope.row)" type="text" size="small">提交
              </el-button>
              <el-button class="tableBtn" v-if="roleName === '招商员'" @click="deleteFun(scope.row)" type="text"
                size="small">删除
              </el-button>
              <el-button class="tableBtn"
                v-if="(roleName === '招商员'&& (scope.row.contractStatus === 0 || scope.row.contractStatus === 1) ) || (roleName === '招商经理' && (scope.row.contractStatus === 2 || scope.row.contractStatus === 3))"
                @click="editFun(scope.row)" type="text" size="small">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody"></el-pagination>
    </div>
    <!--    归档弹框 弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="fileVisible" center>
        <span>请上传已盖章的合同（PDF版）</span>
        <el-upload style="display: block;margin-left: 30%;margin-top: .2rem" ref="uploadFile" action=""
          :auto-upload="false" :http-request="httpRequest" :on-change="handleChange" :on-remove="handleRemove"
          :file-list="fileList" show-file-list accept=".pdf" :limit="1">
          <el-button style="width: 1.5rem"><i class="el-icon-upload2"></i>上传合同</el-button>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button @click="fileVisible = false">取 消</el-button>
          <el-button type="primary" @click="importFun()">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    审批 弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="checkVisible" center>
        <div style="margin-bottom: .2rem">
          <span style="margin-right: .2rem">审批结果:</span>
          <el-radio v-model="approved" :label="true">同意</el-radio>
          <el-radio v-model="approved" :label="false">驳回</el-radio>
        </div>
        <span style="margin-right: .2rem">审批意见:</span>
        <el-input type="textarea" style="width: 65%;vertical-align:top;" :autosize="{ minRows: 3, maxRows: 5}"
          placeholder="请输入内容" v-model="approvalText"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="checkVisible = false">取 消</el-button>
          <el-button type="primary" @click="approveEvent()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    删除弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="deleteVisible" center>
        <span>是否确认删除该合同？</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteEvent()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    提交(招商员) 弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="submitVisible" center>
        <span>提交意见:</span>
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" placeholder="请输入内容"
          v-model="submitText"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEvent()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    预览时内容弹框-->
    <div class="previewDialogDiv">
      <el-dialog :visible.sync="previewVisible" center>
        <div ref="printDiv">
          <p class="ql-editor" v-html="content"></p><br/>
          <div class="title" style="width: 2.5rem;margin: 0 auto;">《租金价目表》（人民币）</div>
          <el-table v-loading="loading" :data="previewTableData" border
            :default-sort="{prop: 'id', order: 'descending'}" style="width: 100%" :highlight-current-row="false">
            <template v-for="(item, index) in previewTableColumns">
              <el-table-column :key="index" :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
            </template>
          </el-table>
          <div class="content">
            <div class="word">1.本价目表中的租金总额以租赁面积 {{ contractRentalRelationArea }} 平方米为前提计算。租金计算公式为房屋建筑面积*日租金*365天。</div>
            <div class="word">2.本价目表信息一经提交，无法修改，请慎重计算！</div>
          </div>
          <!--            审核流程列表-->
          <div class="tableProcess" v-if="showProcess">
            <p style="font-size: large;font-weight:600;line-height: .6rem;text-align: center">审核流程</p>
            <div class="searchList">
              <el-table v-loading="loading" :data="tableDataProcess" :default-sort="{prop: 'id', order: 'descending'}"
                style="width: 100%" :highlight-current-row="false"
                :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
                <template v-for="(item, index) in tableColumnsProcess">
                  <el-table-column :key="index" :prop="item.prop" :label="item.label"
                    :width="item.width"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 查看归档列历史表弹窗 -->
    <div class="previewDialogDiv">
      <el-dialog :title="eventControl" :visible.sync="showHistoryDialog" center>
        <el-table :data="historyData">
          <template v-for="(item, index) in fillingHistoryColumns">
            <el-table-column :key="index" :prop="item.prop" :label="item.label"></el-table-column>
          </template>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="downHistory(scope.row)" type="text" size="small">下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-center">
          <el-pagination @current-change="handleHistoryCurrentChange" :current-page.sync="historyCurrentPage"
            :page-size="historyPageSize" layout="total, prev, pager, next, jumper" :total="historyTotalCount"
            class="paginationBody"></el-pagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { fileDownload, downloadPdf } from '../../api/user'
import { listBuildingInfos, listCompanyfInfo, listContractStatusInfo } from '@/api/searchList'
import {
  contractQuery,
  deleteContractInfo,
  addContractApprove,
  fileUpload,
  previewContractDetail,
  filingHistory
} from '@/api/contract'
import base from '@/utils/index'

export default {
  name: 'contractManagePage',
  data () {
    return {
      historyData: [],
      loading: false,
      roleValue: '',
      roleValueList: [],
      companyValueList: [],
      buildingValueList: [],
      contractStatusValueList: [],
      buildingId: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      historyCurrentPage: 1,
      historyTotalCount: 0,
      historyPageSize: 10,
      eventControl: '',
      contractNumber: '',
      contractName: '',
      companyId: '',
      status: '',
      timeValue: '',
      companyAddress: '',
      approvalText: '',
      submitText: '',
      roleName: '',
      deleteId: '',
      submitId: '',
      approveId: '',
      approved: '',
      fileId: '',
      printCheckId: '',
      rentalDetailAddr: '',
      isFileSelected: false,
      fileList: [],
      showProcess: false,
      // 预览的表格数据
      previewTableData: [],
      previewTableColumns: [
        // {
        //   prop: 'id',
        //   label: '项目'
        // },
        {
          prop: 'rentalDate',
          label: '租赁期限',
          width: '200px'

        },
        {
          prop: 'rentalUnit',
          label: '每期租金（元）'
        },
        {
          prop: 'rentalSum',
          label: '租金总额（元）'
        },
        {
          prop: 'dailyRental',
          label: '日租金（元/天/平米）'
        },
        // {
        //   prop: 'manageFee',
        //   label: '物业管理费（元）'
        // },
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      tableDataProcess: [],
      tableColumnsProcess: [
        {
          prop: 'roleName',
          label: '处理角色'
        },
        {
          prop: 'createUser',
          label: '处理人'
        },
        {
          prop: 'processRemark',
          label: '提交意见'
        },
        {
          prop: 'createTime',
          label: '时间'
        }
      ],
      contractRentalRelationArea: '', // 预览最后的租赁面积参数
      content: '', // 预览内容
      // 弹出框
      printNoCheckVisible: false,
      printCheckVisible: false,
      fileVisible: false,
      deleteVisible: false,
      checkVisible: false,
      submitVisible: false,
      previewVisible: false,
      showPrintBtn: false,
      showHistoryDialog: false,
      tableData: [],
      tableColumns: [
        {
          prop: 'contractNumber',
          label: '合同编号'
        },
        {
          prop: 'contractName',
          label: '合同名称',
          width: '200'
        },
        {
          prop: 'companyName',
          label: '所属公司'
        },
        {
          prop: 'buildingName',
          label: '楼宇名称'
          // formatter: (row, column, v) => {
          //   return this.buildingValueList.find(v2 => v2.buildingId === v).buildingName
          // }
        },
        // {
        //   prop: 'contractStatus',
        //   label: '合同状态',
        //   formatter: (row, column, v) => {
        //     return this.contractStatusValueList.find(v2 => v2.status === v).value
        //   }
        // },
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      fillingHistoryColumns: [
        {
          prop: 'contractNumber',
          label: '合同编号'
        },
        {
          prop: 'filingName',
          label: '合同名称',
          width: '200'
        },
        {
          prop: 'companyName',
          label: '所属公司'
        }
      ]
    }
  },

  mounted () {
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
    this.getCompanyList()
    this.getBuildingList()
    this.getContractStatusList()
    this.getData()
  },
  methods: {
    async pricePreview(row) {
      console.log();
      let res = await fileDownload(row.attachmentUrl)
            let blob = new Blob([res.data], { type: res.data.type })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `价格审批单.${row.attachmentUrl.split('.')[1]}`
            link.click()
    },
    // 查看归档历史
    showHistoryList (row) {
      this.showHistoryDialog = true
      this.queryHistoryList(row)
    },
    // 查询归档历史
    async queryHistoryList (row) {
      const { code, result: { total, records } } = await filingHistory({
        // contractName: row.contractName,
        contractNumber: row.contractNumber,
        // filingName: '',
        pageNum: this.historyCurrentPage,
        pageSize: this.historyPageSize
      })
      if (code === 0) {
        records.map(item => {
          item.filingName = item.filingName.replace('.pdf', '')
        })
        this.historyData = records
        this.historyTotalCount = total
      }
    },
    // 下载归档文件
    async downHistory (row) {
      let res = await fileDownload(row.filingUrl)
      let blob = new Blob([res.data], { type: res.data.type })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = row.filingName + '.pdf'
      link.click()
    },
    // 查询
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    async queryList () {
      let res = await contractQuery({
        contractNumber: this.contractNumber,
        rentalDetailAddr: this.rentalDetailAddr,
        contractName: this.contractName,
        companyId: this.companyId,
        buildingId: this.buildingId,
        contractStatus: this.status,
        contractStartDateFrom: this.timeValue === null ? '' : this.timeValue[0],
        contractEndDateTo: this.timeValue === null ? '' : this.timeValue[1],
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    // 公司下拉框
    async getCompanyList () {
      let res = await listCompanyfInfo({})
      if (res.code === 0) {
        this.companyValueList = res.result
      }
    },
    // 所属楼宇下拉框
    async getBuildingList () {
      let res = await listBuildingInfos({})
      if (res.code === 0) {
        this.buildingValueList = res.result
      }
    },
    // 合同状态下拉框
    async getContractStatusList () {
      let res = await listContractStatusInfo({})
      if (res.code === 0) {
        this.contractStatusValueList = res.result
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    handleHistoryCurrentChange (val) {
      this.historyCurrentPage = val
      this.queryHistoryList()
    },
    // 打印时跳转页面
    printFun (row) {
      this.$router.push({
        path: '/contract/previewContract',
        query: {
          id: row.id,
          contractNumber: row.contractNumber,
          contractStatus: row.contractStatus,
          companyName: row.companyName
        }
      })
    },
    // 归档
    fileFun (row) {
      this.fileVisible = true
      this.eventControl = '归档'
      this.fileId = row.contractNumber
    },
    // 删除
    deleteFun (row) {
      this.deleteVisible = true
      this.eventControl = '删除'
      this.deleteId = row.id
    },
    // 提交
    submitFun (row) {
      // console.log(row)
      this.submitVisible = true
      this.eventControl = '提交'
      this.submitId = row.contractNumber
    },
    // 审批
    checkFun (row) {
      this.checkVisible = true
      this.eventControl = '审批'
      this.approveId = row.contractNumber
    },
    // 预览合同
    async previewFun (row) {
      // if (row.contractStatus !== 0 && row.contractStatus !== 3) {
      //   this.showProcess = true
      // } else {
      //   this.showProcess = false
      // }
      let res = await previewContractDetail({
        id: row.id
      })
      if (res.code === 0) {
        let previewTableDataNew = []
        this.previewVisible = true
        this.content = res.result.contractFormatContent
        // this.previewTable = res.result.contractRentalRelationList
        res.result.contractRentalRelationList.forEach((item) => {
          previewTableDataNew.push({
            id: item.id,
            rentalDate: item.rentalStartDate + ' -- ' + item.rentalEndDate,
            rentalUnit: item.rentalUnit,
            rentalSum: item.rentalSum,
            dailyRental: item.dailyRental,
            manageFee: item.manageFee,
            remark: item.remark
          })
        })
        this.previewTableData = previewTableDataNew
        this.contractRentalRelationArea = res.result.contractRentalRelationArea
        // this.tableDataProcess = res.result.contractProcessEntityList
        this.tableDataProcess = res.result.contractProcessPrintMixInfoList
        console.log(this.previewTableData)
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    addContract () {
      this.$router.push({
        path: '/contract/addContract',
        query: {
          isEdit: false
        }
      })
    },
    editFun (row) {
      this.$router.push({
        path: '/contract/addContract',
        query: {
          isEdit: true,
          id: row.id
        }
      })
    },
    // 确认删除接口
    async deleteEvent () {
      let res = await deleteContractInfo({
        id: this.deleteId
      })
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.deleteVisible = false
        this.getData()
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    // 提交接口（招商员）
    async submitEvent () {
      let res = await addContractApprove({
        approved: true,
        contractNumber: this.submitId,
        processRemark: this.submitText
      })
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '提交成功'
        })
        this.submitVisible = false
        this.getData()
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    // 审批接口
    async approveEvent () {
      let res = await addContractApprove({
        approved: this.approved,
        contractNumber: this.approveId,
        processRemark: this.approvalText
      })
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '审批成功'
        })
        this.checkVisible = false
        this.getData()
      } else {
        this.$message({
          type: 'success',
          message: res.message
        })
      }
    },
    // 根据合同审核状态和当前登录的用户类型 获取是否有“审批”按钮
    getInfoByContractStatus (roleName) {
      let result
      for (let i of this.contractStatusValueList) {
        if (i.roleName === roleName) {
          result = i.status
        }
      }
      return result
    },
    // 上传文件
    async httpRequest (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      fd.append('contractNumber', this.fileId)
      let res = await fileUpload(fd)
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        await this.getData()
        this.fileList = []
        this.isFileSelected = false
        this.fileVisible = false
      } else {
        this.$message.error(res.message)
      }
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file && fileList.length) {
        this.isFileSelected = true
      }
    },
    handleRemove (file, fileList) {
      if (!fileList.length) {
        this.isFileSelected = false
      }
    },
    // 上传文件，提交审核
    importFun () {
      if (this.isFileSelected) {
        this.$refs.uploadFile.submit()
      } else {
        this.$message.error('请选择文件！')
      }
    },
    // 下载pdf
    async downloadPdf (row) {
      const url = process.env.VUE_APP_BASE_API + `/contractInfo/fileDownload?id=${row.id}`
      const res = await downloadPdf({ url })
        var blob = new Blob([res.data], { type: res.data.type });
        var downloadUrl = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = downloadUrl;
        a.download = row.contractName + '.pdf'
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);
        }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}
.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  display: flex;
  justify-content: flex-start; /*两端对齐，子元素之间有间隙*/
  flex-flow: row wrap; /*子元素溢出父容器时换行*/
  .stateDiv {
    width: 3.7rem;
    margin-top: 0.14rem;
  }
  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }
  .stateDivText {
    margin-top: 0.14rem;
  }
  .inputDiv {
    width: 2.2rem;
    float: left;
  }
  .btnDiv {
    margin-left: 1rem;
  }
  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.16rem;
    margin-left: .3rem;
    /*padding-top: 0.09rem;*/
    /*text-align: center;*/
  }
}
.table {
  margin-top: 1.3rem;
  margin-left: .3rem;
  text-align: center;
  width: 14.8rem;
  .searchList {
  }
  .paginationBody {
    margin-top: .1rem;
  }
}
.formItem {
  width: 3.2rem;
}
/deep/ .el-dialog {
  width: 23% !important;
}
.previewDialogDiv {
  /deep/ .el-dialog {
    width: 50% !important;
  }
}
.dialog-center {
  text-align: center;
  margin-top: 15px;
}
</style>
